module.exports = "<div class=\"igo-panel-header\">\r\n  <h3>\r\n    <ng-content select=\"[panelLeftButton]\"></ng-content>\r\n    <div class=\"igo-panel-title\">\r\n      {{title}}\r\n      <ng-content select=\"[panelHeader]\"></ng-content>\r\n    </div>\r\n    <ng-content select=\"[panelRightButton]\"></ng-content>\r\n  </h3>\r\n</div>\r\n<div class=\"igo-panel-content\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/shared/panel/panel.component.html
// module id = 859
// module chunks = 0